import { render, staticRenderFns } from "./FddBl.vue?vue&type=template&id=3de9a854&scoped=true&"
import script from "./FddBl.vue?vue&type=script&lang=js&"
export * from "./FddBl.vue?vue&type=script&lang=js&"
import style0 from "./FddBl.vue?vue&type=style&index=0&id=3de9a854&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de9a854",
  null
  
)

/* custom blocks */
import block0 from "./FddBl.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports